<template>
  <section
    class="full-bleed-img-text"
    :class="[data.fb_layout.value, data.fb_img_orientation.value]">
    <div
      class="fb-img-container"
      :class="{ 'container med': data.fb_layout.value == 'standard' }">
      <div class="image-container">
        <img
          v-lazy="data.full_bleed_img_img.url"
          :alt="data.full_bleed_img_img.alt" />
      </div>
      <div class="fb-content-container">
        <div
          class="eyebrow"
          v-html="data.full_bleed_img_text_tagline"></div>
        <div
          class="headline"
          :class="data.fb_layout.value == 'standard' ? 'h3' : 'h2'"
          v-html="data.full_bleed_img_text_headline"></div>
        <div
          class="text editor-formatting font-larger"
          v-html="data.full_bleed_img_text_text"></div>
        <a
          v-if="data.full_bleed_img_cta"
          class="btn"
          :href="data.full_bleed_img_cta.url"
          :target="data.full_bleed_img_cta.target"
          >{{ data.full_bleed_img_cta.title }}</a
        >
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "FullBleedImageTextComponent",
    "CLASSNAME": "full-bleed-img-text",
    "URL": "http://eikon.local/"
   }
  #ENDMETA */

defineProps(['data'])
</script>

<style lang="scss">
.full-bleed-img-text {
  @include mobile {
    padding-bottom: 50px;
  }

  &.standard {
    padding: 100px 0;

    @include mobile {
      padding: 50px 0;
    }

    &.right {
      .fb-img-container {
        .image-container {
          margin-right: 0;
          margin-left: 10%;

          @include mobile {
            margin: 0 0 40px;
          }
        }
      }
    }

    .fb-img-container {
      height: auto;
      align-items: center;

      .image-container {
        max-width: 450px;
        height: auto;
        margin-right: 10%;
        border-radius: 16px;

        &:after {
          display: none;
        }
      }

      .fb-content-container {
        max-width: 580px;
        padding: 0;
      }
    }
  }

  &.right {
    .fb-img-container {
      .image-container {
        order: 1;

        @include mobile {
          order: 0;
        }

        &:after {
          transform: rotate(180deg);

          @include mobile {
            transform: rotate(0deg);
          }
        }
      }

      .fb-content-container {
        order: 0;
      }
    }
  }

  .fb-img-container {
    display: flex;
    justify-content: space-between;
    height: 600px;

    @include mobile {
      flex-direction: column;
      height: auto;
    }

    .image-container {
      position: relative;
      width: 45%;
      height: 100%;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, rgba(83, 64, 226, 0) 0%, #fff 100%);

        @include mobile {
          top: 1px;
          background: linear-gradient(
            180deg,
            rgba(83, 64, 226, 0) 0%,
            $white 85.19%
          );
        }
      }

      @include mobile {
        width: 100%;
        height: 400px;
      }

      img {
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: right;
      }
    }

    .fb-content-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-self: center;
      padding: 120px 4% 120px 5%;

      @include mobile {
        padding: 0px 5%;
      }

      .eyebrow {
        margin: 0 0 40px;
      }

      .headline {
        margin: 0 0 24px;
      }

      .btn {
        margin: 24px 0 0;
        align-self: flex-start;
      }
    }
  }
}
</style>
